
import { FC } from "react";
import React, { useEffect } from "react";
import { useAppDispatch } from "src/hooks";
import { useAppSelector } from '../../hooks';
import { useNavigate, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import "src/styles/profile.css";
import { useState } from "react";
import Asynchronous from '../../components/jsx_components/Autocomplete';

import { contactsData3 } from './../../features/contacts/WagonContactsActions';

import { contactDataByID, contactsData } from './../../features/contacts/contactsActions';
import InputPhoneField from '../../components/jsx_components/InputPhoneField';
import { Box } from "@mui/system";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import { PhoneArr, EmailArr, Client, Contact, ClientWithID, ContactWithID, ContactWithOutID, TypeSnack } from '../../types/request.type';

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

import 'dayjs/locale/ru';

import { ruRU } from '@mui/x-date-pickers/locales';
import { ruRU as dataGridruRU } from '@mui/x-data-grid';
import { ruRU as coreruRU } from '@mui/material/locale';

import { createTheme } from '@mui/material/styles';

import { contactsDataPost, contactsDataUpdate } from './../../features/contacts/contactsActions';


import {
  setName0, setClientContacts0, setPhones0, setEmails0, setPosition0, setComment0, setReset0
} from "src/features/contacts/createNewContactSlice";




const theme = createTheme(
  {
    palette: {
      primary: { main: '#1976d2' },
    },
  },
  ruRU,
  dataGridruRU,
  coreruRU, // core translations
);


export const CreateContactPage: FC = () => {

  const [snackbar, setSnackbar] = React.useState<TypeSnack>(null);
  const handleCloseSnackbar = () => { setSnackbar(null); navigate('/contacts'); };
  const handleCloseSnackbar0 = () => { setSnackbar(null); };

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const contactRequest = useAppSelector(state => state.contact_request.contact_request);
  
  const contactRequestID = useAppSelector(state => state.contact_requestID.contactRequest);

  const idRequest = params.idRequest;

  //Need refresh
  const [needRefresh, setNeedRefresh] = useState<boolean>(false);

  const [asynchronous2, setAsynchronous2] = useState<number[]>([1]);

  // Клиенты
  const [clients1, setClients1] = useState<Client>("");
 // const [clients1_id, setClients1_id] = useState<ClientWithID>();

  //Контакты
  const [contacts2, setContacts2] = useState<Contact>("");
  const [contacts2_id, setContacts2_id] = useState<ContactWithID>(null);


  //Клиенты и контакты 1
  const childToParent1_clients = (childdata1: Client) => {
   
    setClients1(childdata1);
    setContacts2("");
  };

  const childToParent1_id_clients = (childdata1: ClientWithID) => {
    
    let new_contact = {id: childdata1.id, title: childdata1.title };
    dispatch(setClientContacts0(new_contact));   
    setContacts2_id(null);

  };

  // Клиенты
  const [clients3, setClients3] = useState<Client>("");
  const [clients3_id, setClients3_id] = useState<ClientWithID>();

  //Контакты
  const [contacts3, setContacts3] = useState<Contact>("");
  const [contacts3_id, setContacts3_id] = useState<ContactWithID>(null);

  ////////////////////////////////////////////////////////////////////////////////////

  // Parent To Child
  const handleParentToChild = () => {

  };

  //То что в компоненты идет

  const { dataClients } = useAppSelector((state) => state.clients);
  const { dataContacts } = useAppSelector((state) => state.contacts);
  const { dataWagonTypes } = useAppSelector((state) => state.wagontypes);
  const { dataRequestTypes } = useAppSelector((state) => state.requesttypes);


  //Контакты
  useEffect(() => {

    dispatch(contactsData3()); // то что в экшине

  }, [dispatch]);


const sendValueInsert = (contact: ContactWithOutID) => {

  dispatch(contactsDataPost(contact)).then(() => {

    if (contactRequest?.client !== undefined) dispatch(contactsData(contactRequest?.client));  
 
  })

}

const sendValueUpdate = (contact: ContactWithID) => {

  dispatch(contactsDataUpdate(contact)).then(() => {
   
   if (contactRequest?.client !== undefined) dispatch(contactsData(contactRequest?.client));

  })

}

  //Редактура запроса
  useEffect(() => {


    if (idRequest !== undefined && Number(idRequest) > 0) {
      dispatch(contactDataByID(Number(idRequest))).then(() => { 
       
        dispatch(setReset0());

       //dispatch()
        dispatch(setName0(contactRequestID !== null ? contactRequestID.name : ""));
        dispatch(setClientContacts0(contactRequestID !== null ? contactRequestID.client : {id: 0, title: ""}));
        dispatch(setPhones0(contactRequestID !== null ? contactRequestID.phones : []));
        dispatch(setEmails0(contactRequestID !== null ? contactRequestID.emails : []));
        dispatch(setPosition0(contactRequestID !== null ? (contactRequestID.position === undefined ? "" : contactRequestID.position) : ""));
        dispatch(setComment0(contactRequestID !== null ? (contactRequestID.comment === undefined ? "" : contactRequestID.comment) : ""));

        setPhone(contactRequestID?.phones!);
        setEmail(contactRequestID?.emails!);

      })

    }

    if ((idRequest !== undefined && Number(idRequest) === 0) || idRequest === undefined) {

      dispatch(setReset0());

    }

    /// }, [dispatch, idRequest, repairRequestID.client_contacts.length, repairRequestID.wagon_contacts.length]);  //[idRequest, dispatch]);

  }, [idRequest, dispatch, contactRequestID?.comment, contactRequestID?.position, contactRequestID?.name],
  );  //[idRequest, dispatch]);//contactRequestID, dispatch, idRequest

  //, contactRequestID?.client, contactRequestID?.comment, contactRequestID?.position, contactRequestID?.phones, contactRequestID?.emails

  /////////////////////////////////////////////////////////////////////////////////


  const [phone, setPhone] = useState<PhoneArr>([]);
  const [phoneEmpty, setPhoneEmpty] = useState<string>("4959193739");

  const [email, setEmail] = useState<EmailArr>([]);
  const [emailEmpty, setEmailEmpty] = useState<string>("t-64@mail.ru");


  //const [name, setName] = useState<string>("");
  //const [position, setPosition] = useState<string>("");
  //const [comment, setComment] = useState<string>("");

  //Добавить объект в массив
  const addNewPhoneToArray = (newPhone: string) => {
    setPhone([...phone, newPhone]);
  };

  //Удалить объект из массива 
  const removePhoneToArray = (index: number) => {
    setPhone([
      ...phone.slice(0, index),
      ...phone.slice(index + 1, phone.length),
    ]);
  };

  //Добавить объект в массив
  const addNewEmailToArray = (newEmail: string) => {
    setEmail([...email, newEmail]);



  };

  //Удалить объект из массива 
  const removeEmailToArray = (index: number) => {
    setEmail([
      ...email.slice(0, index),
      ...email.slice(index + 1, email.length),
    ]);
  };


  const [isValidPhone0, setIsValidPhone0] = useState<boolean>(false);
  const [isValidEmail0, setIsValidEmail0] = useState<boolean>(false);



  /////////////////////////////////////////////////////////////////////////////////////

  //Контакты
  const childToParent2_contacts = (childdata2: Contact) => {

    dispatch(setName0(childdata2 !== null ? childdata2 : ""));

    setNeedRefresh(false);
    setContacts2(childdata2);
    setPhone([]);
    setEmail([]);
  };

  const childToParent2_id_contacts = (childdata2: ContactWithID) => {
    setContacts2_id(childdata2);

    setPhone([]);
    childdata2?.phones?.map(function (object, i) {

      setPhone((phone) => [object, ...phone]);
    
    
    });


    setEmail([]);
    childdata2?.emails?.map(function (object, i) {

      setEmail((email) => [object, ...email]);
    
    
    });


  };


  //Обновление телефона
  const handlePhoneNumberChange0 = (value: string, isValid: boolean, number: number) => {
    let phone2 = [...phone];
    phone2[number] = value;
    setPhone(phone2);
    setIsValidPhone0(isValid);
  };

  //Обновление email
  const handleEmailChange0 = (value: string, isValid: boolean, number: number) => {
    let email2 = [...email];
    email2[number] = value;
    setEmail(email2);
    setIsValidEmail0(isValid);
  };



  const saveRequest = (saveas: boolean) => {

    
    if (contactRequest?.client !== undefined) {

      dispatch(setPhones0(phone));
      dispatch(setEmails0(email));

      let contact_data: ContactWithID = {
        id: idRequest !== undefined && Number(idRequest) > 0 ? Number(idRequest) : 0,
        client: contactRequest?.client!,//clients1_id,
        name: contactRequest?.name,
        phones: phone,
        emails: email,
        position: contactRequest?.position,
        comment: contactRequest?.comment,  
      };

      contact_data.id > 0 ? sendValueUpdate(contact_data) : sendValueInsert(contact_data);

      let textSnack: TypeSnack = {
        children: contact_data.id > 0 ? 'Изменили запрос' : 'Создали запрос',
        title: 'success',
      };

      setSnackbar(textSnack);

    }



  };

  return (

    <div className="main-page" style={{ height: "100%", width: "1200px", left: '0px', top: '0px', }}>

<Asynchronous
        key={"child1"}
        clear={false}
        sx={{display: "block", height: "55px", marginTop: "20px", width: 500}}
        childToParent={childToParent1_clients}
        childToParent_id={childToParent1_id_clients}
        dataParentToChild={handleParentToChild}
        
        value2={Number(idRequest) !== 0 ? (contactRequest?.client.title) : ""}

        dataRows={
          dataClients?.payload?.list
            ? dataClients?.payload?.list.map((option) => ({
              id: option.id,
              title: option.title,
              label: option.title,
            }))
            : []
        }
        field={"title"} // label
        name={"Клиент"}
        freesl={false}
      />

      <Asynchronous
        key={"child2"}
        clear={(!contactRequest?.client ? true : false) || needRefresh}
        sx={{ display: "block", height: "55px", marginTop: "20px", width: 500 }}
        childToParent={childToParent2_contacts}
        childToParent_id={childToParent2_id_contacts}
        dataParentToChild={handleParentToChild}
        dataRows={
          dataContacts?.payload && /*clients1_id*/ contactRequest?.client && typeof dataContacts?.payload?.map === "function"
            ? dataContacts?.payload?.map((option) => ({
              id: option?.id,
              client: option?.client,
              comment: option?.comment,
              emails: option?.emails,
              name: option?.name,
              phones: option?.phones,
              position: option?.position,
              label: option?.name + ""
            }))
            : []
        }
        field={"name"}
        value2={Number(idRequest) !== 0 ? (contactRequest?.name) : ""}
        name={"Контакт"}
        freesl={true}
      />


      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 500 }}>
        <InputLabel shrink htmlFor="text-mask-input">
          {"Должность"}
        </InputLabel>
        <OutlinedInput
          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}
          placeholder={"Должность"}

          //value={Number(idRequest) !== 0 ? (contactRequest?.position !== null ? contactRequest?.position : "") : ""}

          value = {contactRequest?.position}

          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(setPosition0(e.target.value));
          }}

          name="position"
          label={"Должность"}
          fullWidth={true}
          size={"small"}
          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>


      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 500 }}>
        <InputLabel shrink htmlFor="text-mask-input">
          {"Комментарий"}
        </InputLabel>
        <OutlinedInput
          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}
          placeholder={"Комментарий"}

          //value={comment}
          
          value = {contactRequest?.comment}
          //value={Number(idRequest) !== 0 ? (contactRequest?.comment !== null ? contactRequest?.comment : "") : ""}


          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            //setComment(e.target.value);
            dispatch(setComment0(e.target.value));
          }}

          name="comment"
          label={"Комментарий"}
          fullWidth={true}
          size={"small"}

          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>

      {phone && phone.length ? (
        phone?.map((object, i) => (
          <React.Fragment key={object + String(i)}>


            <Box sx={{ marginTop: "20px" }}>
              <InputPhoneField
                placeholder="Номер телефона"
                helperText="Номер телефона"
                label="Phone"
                fieldName="Phone"
                objectPhone={phone[i]}
                value={phone[i]}
                handleChange={handlePhoneNumberChange0}
                array={i}
              />

            </Box>


          </React.Fragment>
        ))
      ) : (
        <></>
      )}


      {email && email.length ? (
        email?.map((object, i) => (
          <React.Fragment key={object + String(i)}>

            <Box sx={{ marginTop: "20px" }}>
              <InputPhoneField
                helperText="Электронная почта"
                placeholder="Электронная почта"
                label="Email"
                fieldName="Email"
                objectPhone={email[i]}
                value={email[i]}
                handleChange={handleEmailChange0}
                array={i}
              />
            </Box>

          </React.Fragment>
        ))
      ) : (
        <></>
      )}

      <Button
        sx={{
          color: "white",
          backgroundColor: "#16b8f3",
          top: 40 ,
          width: 190,
          left: 750,
          height: 40,
          position: "absolute",
          transform: "translateY(-50%)",

          "&:hover": {
            backgroundColor: "#12a8df",
          },
        }}
        variant="contained"
        onClick={() => {
          if (contacts2 || contactRequest) addNewPhoneToArray(phoneEmpty);
        }}
      >
        Добавить телефон
      </Button>

      <Button
        sx={{
          color: "white",
          backgroundColor: "#16b8f3",
          top: 90,
          width: 190,
          left: 750,
          height: 40,
          position: "absolute",
          transform: "translateY(-50%)",

          "&:hover": {
            backgroundColor: "#12a8df",
          },
        }}
        variant="contained"
        onClick={() => {
          if (contacts2 || contactRequest) removePhoneToArray(phone.length - 1);
        }}
      >
        Убрать телефон
      </Button>

      <Button
        sx={{
          color: "white",
          backgroundColor: "#16b8f3",
          top: 140,
          width: 190,
          left: 750,
          height: 40,
          position: "absolute",
          transform: "translateY(-50%)",

          "&:hover": {
            backgroundColor: "#12a8df",
          },
        }}
        variant="contained"
        onClick={() => {
          if (contacts2 || contactRequest) addNewEmailToArray(emailEmpty);

          let textSnack: TypeSnack = {
            children: 'Добавили email',
            title: 'success',
          };

         // setSnackbar(textSnack);

        }}
      >
        Добавить Email
      </Button>

      <Button
        sx={{
          color: "white",
          backgroundColor: "#16b8f3",
          top: 190,
          width: 190,
          left: 750,
          height: 40,
          position: "absolute",
          transform: "translateY(-50%)",

          "&:hover": {
            backgroundColor: "#12a8df",
          },
        }}
        variant="contained"
        onClick={() => {
          if (contacts2 || contactRequest) removeEmailToArray(email.length - 1);
        }}
      >
        Убрать Email
      </Button>

{/*

      <Button
        sx={{
          color: "white",
          backgroundColor: "#16b8f3",
          bottom:  200,
          right: 140,
          height: 40,
          width: 250,
          position: "absolute",
          // transform: "translateY(-50%)",

          "&:hover": {
            backgroundColor: "#12a8df",
          },
        }}
        variant="contained"
        onClick={() => {


          if (!contacts2) { alert('Не задан контакт!'); return; }

          if (!isValidPhone0 || phone?.length === 0) { alert('Неверный телефон!'); return; }
          if (!isValidEmail0 || email?.length === 0) { alert('Неверный емейл!'); return; }
          if (contactRequestID?.client.id !== undefined) {
          
            let contact: ContactWithOutID = {
              client:  contactRequestID?.client,
              name: contacts2,
              phones: phone,
              emails: email,
              position: contactRequestID?.position,
              comment: contactRequestID?.comment,
            };

            sendValueInsert(contact);

            let textSnack: TypeSnack = {
              children: 'Создали контакт',
              title: 'success',
            };

            setSnackbar(textSnack);

          }

        }}
      >
        Новый контакт
      </Button>


      <Button
        sx={{
          color: "white",
          backgroundColor: "#16b8f3",
          bottom: 150,
          width: 250,
          right: 140,
          height: 40,
          position: "absolute",
          // transform: "translateY(-50%)",

          "&:hover": {
            backgroundColor: "#12a8df",
          },
        }}
        variant="contained"
        onClick={() => {

          if (!contacts2) { alert('Не задан контакт!'); return; }
          if (contacts2_id?.id === undefined) { alert('Контакт не может быть изменен, т.к. ранее не создавался !'); return; }


          if (!isValidPhone0 || phone?.length === 0) { alert('Неверный телефон!'); return; }
          if (!isValidEmail0 || email?.length === 0) { alert('Неверный емейл!'); return; }

          if ( contactRequestID?.client.id !== undefined && contacts2_id?.id !== undefined) {

            let contact: ContactWithID = {
              id: contacts2_id?.id,
              client: contactRequestID?.client!,//clients1_id,
              name: contacts2,
              phones: phone,
              emails: email,
              position: contactRequestID?.position,
              comment: contactRequestID?.comment,
            };

            sendValueUpdate(contact);

            let textSnack: TypeSnack = {
              children: 'Изменили контакт',
              title: 'success',
            };

            setSnackbar(textSnack);

          }

        }}
      >
        Изменить контакт
      </Button>

*/}
      
      
      













      <Button
        sx={{

          color: "white",
          backgroundColor: "#16b8f3",

          position: "absolute", height: "35px", bottom: Number(idRequest) > 0 ? "50px" : "50px", width: 250, right: 145,

          transform: "translateY(-50%)",

          "&:hover": {
            backgroundColor: "#12a8df",
          },
        }}
        variant="contained"
        onClick={() => {

          if (!contacts2 && !contactRequest) { alert('Не задан контакт!'); return; }
          if (!isValidPhone0 || phone?.length === 0) { alert('Неверный телефон!'); return; }
          if (!isValidEmail0 || email?.length === 0) { alert('Неверный емейл!'); return; }

          Number(idRequest) > 0 ? saveRequest(false) : saveRequest(true);

          let textSnack: TypeSnack = {
            children:  Number(idRequest) > 0 ? 'Изменили контакт' : 'Создали контакт',
            title: 'success',
          };

          setSnackbar(textSnack);


        }}
      >
        {Number(idRequest) > 0 ? "Изменить" : "Сохранить"}
      </Button>


      {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={handleCloseSnackbar}
          autoHideDuration={2000}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
      )}  



      <Button autoFocus
        sx={{

          color: "white",
          backgroundColor: "#16b8f3",

          position: "absolute", height: "35px", bottom: "5px", width: 250, right: 145,

          transform: "translateY(-50%)",

          "&:hover": {
            backgroundColor: "#12a8df",
          },
        }}
        variant="contained"
        onClick={() => {

          navigate('/contacts');
        }}
      >
        Отмена
      </Button>

    </div>

  )
}


